var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticClass:"d-flex"},[_c('div',{class:[
        'grey--text text-capitalize my-2',
        _vm.className ? _vm.className : ''
      ],domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }